/**
 * Screen Wake Lock helpers for active OSINT scans (mobile).
 * No-ops when the API is unavailable.
 */

/**
 * @returns {Promise<WakeLockSentinel|null>}
 */
export async function requestScanWakeLock() {
  if (typeof navigator === 'undefined' || !navigator.wakeLock?.request) {
    return null;
  }
  try {
    return await navigator.wakeLock.request('screen');
  } catch {
    return null;
  }
}

/**
 * @param {WakeLockSentinel|null|undefined} lock
 * @returns {Promise<void>}
 */
export async function releaseScanWakeLock(lock) {
  if (!lock) return;
  try {
    if (!lock.released) {
      await lock.release();
    }
  } catch {
    /* ignore */
  }
}
